angular.module('lf.common')

.controller('SubscriptionLoginCtrl', function ($scope, $injector, subscriptionService, authenticationService, gtmService) {
  var client = lf.data.xhr.client;
  var isDesktop = client.isDesktop || client.isLFC;
  var popupsService = $injector.get(isDesktop ? 'popupsService' : '$popups');
  
  $scope.loginForm = {
    email: lf.data.xhr.user.emailAddress
  }
  
  $scope.error = null;
  
  $scope.login = function () {
    $scope.processing = true;
    $scope.error = null;
    popupsService.show('processing');
    
    subscriptionService.loginUser({
      login: $scope.loginForm.email,
      password: $scope.loginForm.password
    })
      .success(function (data) {
        if (data.success) {
          $scope.error = null;
          if (data.subscription.isEligible) {
            if (data.subscription.isSignedUp) {
              popupsService.show('already-signed-up');
            } else {
              gtmService.subscription.login.trackSuccessfulLogin();
              setTimeout(function () {
                window.location = lf.data.xhr.siteBaseUrl + data.subscription.redirectUrl;
              }, 500);
            }
          } else {
            popupsService.show('not-eligible');
          }
        } else {
          $scope.error = {};
          if (data.error && data.error.details && data.error.details.length) {
            $scope.error.message = data.error.details[0];
          } else {
            $scope.error.serverError = true;
          }
          gtmService.subscription.login.trackUnsuccessfulLogin();
        }
      })
      .error(function () {
        $scope.error = { serverError: true };
        gtmService.subscription.login.trackUnsuccessfulLogin();
      })
      .finally(function () {
        $scope.processing = false;
        popupsService.hide('processing');
      });
  }
  
  $scope.showPasswordRecoveryPopup = function () {
    popupsService.show('password-recovery');
    gtmService.subscription.login.trackForgotPasswordLinkClick();
  }
  
});
